module.exports = __webpack_public_path__ + "static/img/pad_content.dcc1deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/pad_content.png
// module id = Dmp3
// module chunks = 1